<template>
    <div class="cart-nav">
        <div class="flex cart-nav-content">
            <span v-for="(item, index) in options" :key="index" :class="{
                active: index <= active
            }">{{ item }}</span>
        </div>
        <div class="cart-line normal"></div>
        <div class="cart-line active" :style="{
            width: `${( active + 1 ) * 100 / options.length}%`
        }"></div>
    </div>
</template>

<script>
export default {
    props: {

        options: {

            type: Array,
            default: () => []

        },
        active: Number

    }

};
</script>

<style scoped lang="less">
    .cart-nav{
        color: #8e8e8e;
        max-width: 1040px;
        font-size: 0.16rem;
        position: relative;
        margin: 0 auto 0.6rem;
        @media @mobile{
            display: none;
        }
        .cart-nav-content{
            justify-content: space-between;
            span{
                z-index: 1;
                &.active{
                    color: @theme;
                    &::after{
                        background-color: @theme;
                    }
                }
                &::after{
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    background-color: #b5b5b5;
                    border-radius: 100%;
                    margin: 3px auto 0;
                }
                &:nth-child(2){
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
        .cart-line{
            height: 1px;
            position: absolute;
            bottom: 4px;
            &.normal{
                background-color: #c0c0c0;
                width: 100%;
            }
            &.active{
                background-color: @theme;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/cartNav.vue